import { useTheme, Theme } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { PropsAdronIcon } from "../../../_app/types";

const Bot = ({ size, colorCustom }: PropsAdronIcon) => {
  const theme: Theme = useTheme();
  return (
    <SvgIcon
      viewBox={size ? `0 0 ${size} ${size}` : undefined}
      style={size ? { width: size, height: size } : undefined}
    >
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.875 9.33333C18.3478 9.33333 19.5417 8.13943 19.5417 6.66667C19.5417 5.19391 18.3478 4 16.875 4C15.4022 4 14.2083 5.19391 14.2083 6.66667C14.2083 8.13943 15.4022 9.33333 16.875 9.33333ZM16.875 9.33333V14.6667M7.54167 14.6667H26.2083C27.6811 14.6667 28.875 15.8606 28.875 17.3333V25.3333C28.875 26.8061 27.6811 28 26.2083 28H7.54167C6.06891 28 4.875 26.8061 4.875 25.3333V17.3333C4.875 15.8606 6.06891 14.6667 7.54167 14.6667Z"
          stroke={colorCustom ? colorCustom : theme.palette.text.primary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default Bot;
